/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import RelatedArticle from '../RelatedModule/RelatedArticle';
import SubHead from '../SubHead/SubHead';
import BodyText from '../BodyText/BodyText';
import Ad from '../../../Ad';
import '../RelatedModule/related-module.scss';
import './related-tags.scss';
import { segmentTrackEvent, isValid } from '../../../../utils';
import { APP_ENV } from '../../../../consts';

const RelatedTags = ({
    id,
    data,
    isMobile,
    className,
    isClient,
    hasAds,
    relatedTagsIndex,
    category,
    sponsorship,
    adType,
	articleLayout,
	isPage=false,
}) => {
	if (!isValid(data)) {
		return null;
	}
    const {
		header,
		hedBody,
		articles = [],
		rows = 1,
	} = data;

    const multi = isMobile ? 'row-1x' : 'row-3x';
	const width = (articleLayout === 'Standard') ? 'slim' : 'regular';
    let adCount = 0;
    let placementName = `purewow_relatedtagsmodule_${relatedTagsIndex}_${adCount}`;
    const adUnit = `purewow/${category}/article`;

    const LENGTH = articles.length;
	const setLimit = () => {
		let limit;
		if (isMobile && rows > 0) {
			limit = 3;
		}
		if (!isMobile && rows > 0) {
			limit = 6;
		}
		if (isMobile && rows === 0) {
			limit = 5;
		}
		if (!isMobile && rows === 0) {
			limit = 15;
		}
		return limit;
	};
	const LIMIT = setLimit();
    // boolean logic for when to show/hide the View More button, hide it once we've rendered all the articles
    const [showMore, setShowMore] = useState(false); // was set to true originally
    // initial list of articles to render
    const [list, setList] = useState(articles.slice(0, LIMIT));
    // manages the index
    const [index, setIndex] = useState(LIMIT);

	// Check on initial render if number of rows is greater than 1, show View More button on initial render, else hide it
	useEffect(() => {
		if (isPage) {
			if (articles.length > 30) {
				setList(articles.slice(0, 6));
				setShowMore(true);
			} else {
				setList(articles);
			}
		} else {
			if ((isMobile && rows > 1)
			|| (!isMobile && rows > 2)
			|| ((isMobile && rows === 0) && (articles.length > 5))
			|| ((!isMobile && rows === 0) && (articles.length > 15))) {
				setShowMore(true);
			}
		}
	}, []);

	const handleViewMore = () => {
		const newIndex = index + LIMIT;
		const newShowMore = newIndex < LENGTH;
		const newList = [...list, ...articles.slice(index, newIndex)];
		setIndex(newIndex);
		setList(newList);
		setShowMore(newShowMore);
	    if (scroll === "scroll") {
			segmentTrackEvent('continue', {action: 'more', label: 'more'});
	    }
    };

    const buttonText = 'View More';
	const renderedButton = <div className='button button-text' data-link-type="cta-link">{buttonText}</div>;

	let insertIndex = isMobile ? 3 : 9;
	const articleRows = list.map((article, i) => {
		const currIndex = i;
		const lastArticle = list.length - 1;

		const insertAd = hasAds && ((i + 1) === insertIndex);
        if (insertAd) {
            adCount += 1;
            insertIndex += isMobile ? 3 : 9;
            placementName = `purewow_relatedtagsmodule_${relatedTagsIndex}_${adCount}`;
        }
		const {
		    headline, url, authorName, category, categoryImage, sponsored, credit, creditUrl, recipe_data,
		    } = article;
		const articleData = {
		    articleId: id,
		    articleText: headline,
		    articleUrl: url,
			author: authorName,
		    category,
		    categoryImage,
		    sponsored,
		    credit,
		    creditUrl,
		    recipe_data,
		};

		return (
			<Fragment key={i}>
				<RelatedArticle
					key={id}
					article={articleData}
					className="related-story"
					isMobile={isMobile}
					isPage={isPage}
				/>
				{showMore && (currIndex === lastArticle)
					&& <div className="button-wrapper">
							<div className="large-image-button" onClick={handleViewMore}>
								{renderedButton}
							</div>
						</div>
				}
				{insertAd &&
			    	<div className='htlad-purewow_relatedtagsmodule related-tags-ad article-in-content-ad'
                    	data-unit={adUnit}
                    	data-targeting='{"slot_name":"purewow_relatedtagsmodule"}'></div>
                }
			</Fragment>
		);
	});

    return (
        // className will be 'related-tags' as is declared in ArticleModules.js
        <div className={className}>
			<Fragment>
				{isValid(header) && <SubHead className="related-module-hed" data={header} />}
				{isValid(hedBody) && <BodyText className="related-module-header-body" data={hedBody} />}
				<div className="related-tags-container-wrapper">
					<div className={`${className}-wrapper ${multi} ${width}`}>
						{articleRows}
					</div>
				</div>
			</Fragment>
        </div>
    );
};

RelatedTags.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

export default RelatedTags;
